/* eslint-disable react/style-prop-object */
import { View } from '@fairygodboss/ui';
import React from 'react';

export const DividerSVG = ({ width }) => (
    <View>
        <svg
            width={`${width}%`}
            height="2"
            // viewBox={`0 0 ${width} 2`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width={`${width}%`} height="2" fill="#B394F2" />
        </svg>
    </View>
);

export const ConvincerSVG = () => (
    <svg
        width="270"
        height="110"
        viewBox="0 0 270 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_878_6813)">
            <path
                d="M229.5 101.198L220.7 97.9946L217.497 106.797L226.297 110L229.5 101.198Z"
                fill="#982EA9"
            />
            <rect
                width="9.36528"
                height="9.367"
                transform="matrix(-0.939674 -0.342072 -0.341976 0.939709 152.004 15.2036)"
                fill="#982EA9"
            />
            <path
                d="M180.925 92.9951L174.502 96.8549L178.361 103.279L184.784 99.4187L180.925 92.9951Z"
                fill="#E3C5E7"
            />
            <path
                d="M46.7354 93.5325L39.2831 92.7495L38.4995 100.202L45.9517 100.985L46.7354 93.5325Z"
                fill="#B394F2"
            />
            <rect
                width="4.68458"
                height="4.68505"
                transform="matrix(-0.990265 -0.139198 -0.139149 0.990272 97.8042 17.6516)"
                fill="#BD79C8"
            />
            <rect
                width="4.68458"
                height="4.68505"
                transform="matrix(-0.566367 -0.824154 -0.8241 0.566446 208.013 33.8594)"
                fill="#BD79C8"
            />
            <rect
                opacity="0.8"
                width="7.49326"
                height="7.49356"
                transform="matrix(-0.828994 -0.559257 -0.559129 0.829081 116.913 40.1885)"
                fill="#B394F2"
            />
            <rect
                width="5.61978"
                height="5.62033"
                transform="matrix(-0.97814 -0.207952 -0.207872 0.978157 174.443 34.896)"
                fill="#B394F2"
            />
            <rect
                width="5.61978"
                height="5.62033"
                transform="matrix(-0.97814 -0.207952 -0.207872 0.978157 104.177 100.163)"
                fill="#982EA9"
            />
            <path
                d="M228.496 77.9963C226.585 75.1242 220.69 70.4089 212.398 74.5239"
                stroke="#BD79C8"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M62.9999 83.2926C65.0423 87.1053 70.9216 93.6155 78.099 89.1548"
                stroke="#982EA9"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.7952 53.1486C65.1732 52.8732 64.2632 52.3588 63.2505 51.1041C63.0541 51.1109 62.6364 51.9557 62.7083 52.7893L62.7095 52.8035C62.7924 53.7705 62.9482 55.5885 65.8085 56.8219C65.2302 56.9234 64.4238 56.91 63.6484 56.6024C63.6952 57.9384 64.9277 60.4035 68.7086 60.5227C68.5147 61.0312 67.5423 61.1488 66.9506 61.2112C67.5885 62.4433 69.2265 63.1804 71.0934 63.1572C71.2858 63.1548 71.5458 63.1253 71.8434 63.0916C72.5057 63.0165 73.3546 62.9203 74.06 63.0539C75.2169 63.273 75.67 63.4467 76.4886 64.3859C76.4857 64.3037 76.5111 64.1306 76.547 63.8859C76.7644 62.4032 77.3674 58.2917 74.402 55.8518C74.3458 55.8056 74.291 55.76 74.2368 55.7151C73.0702 54.7472 72.2626 54.0771 66.7952 53.1486ZM67.7096 54.4789C66.547 54.2815 64.9108 53.9974 63.9077 53.2862C64.1538 54.158 64.3689 54.4541 64.8653 54.9169C65.5061 55.5205 67.8564 56.4833 69.2784 57.0658C69.4766 57.147 69.6568 57.2209 69.8118 57.2853L69.7842 57.2901C69.2692 57.3805 66.0805 57.9404 65.4192 58.0327C66.1424 58.9254 67.4466 59.4731 70.333 59.429C70.2967 59.5151 70.2538 59.6525 70.2019 59.8191C70.0203 60.401 69.7278 61.3387 69.2177 61.6888C69.2912 61.7389 69.7224 61.9569 70.9739 62.0051C71.181 62.0025 71.4346 61.974 71.7225 61.9418C72.0532 61.9047 72.4292 61.8626 72.8325 61.8486C73.5871 61.8223 74.6192 61.8569 75.5727 62.2685C75.573 62.264 75.5734 62.259 75.5738 62.2535C75.6059 61.8174 75.8552 58.4248 73.5678 56.6332C73.509 56.5871 73.4522 56.5423 73.3969 56.4987C72.293 55.6283 71.7976 55.2376 67.7096 54.4789Z"
                fill="#BD79C8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63.908 53.2864C64.9111 53.9976 66.5474 54.2817 67.7099 54.4791C72.0026 55.2757 72.334 55.6666 73.5682 56.6334C75.8843 58.4475 75.5996 61.9029 75.5731 62.2687C74.6195 61.8571 73.5874 61.8224 72.8329 61.8487C72.0783 61.875 71.4192 61.9996 70.9743 62.0053C69.7228 61.9571 69.2915 61.7391 69.2181 61.6889C69.8742 61.2386 70.1704 59.8161 70.3333 59.4292C67.447 59.4732 66.1427 58.9255 65.4195 58.0328C66.0941 57.9387 69.3977 57.3582 69.8121 57.2854C68.5453 56.7589 65.5958 55.6048 64.8656 54.9171C64.3693 54.4542 64.1541 54.1581 63.908 53.2864Z"
                fill="#BD79C8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M200.091 55.5045C201.94 55.4195 203.027 54.9701 204.33 53.708C204.548 53.7425 204.899 54.7433 204.705 55.6642L204.701 55.6799C204.476 56.7484 204.053 58.7571 200.69 59.7419C201.322 59.9346 202.224 60.0303 203.133 59.7932C202.897 61.2788 201.183 63.8624 196.944 63.4765C197.091 64.0709 198.161 64.3357 198.813 64.4866C197.932 65.775 196.002 66.3732 193.92 66.0911C193.706 66.062 193.419 65.9934 193.091 65.9148C192.362 65.7401 191.427 65.5161 190.621 65.5685C189.299 65.6544 188.769 65.7861 187.726 66.7226C187.741 66.6312 187.736 66.4344 187.73 66.1563C187.69 64.4707 187.58 59.7966 191.226 57.479C191.295 57.4351 191.362 57.3918 191.429 57.3491C192.864 56.4283 193.858 55.7909 200.091 55.5045ZM198.888 56.8646C200.213 56.8037 202.079 56.711 203.297 56.0545C202.903 56.9942 202.622 57.2954 202.004 57.7441C201.206 58.3302 198.449 59.0827 196.781 59.538C196.549 59.6015 196.337 59.6592 196.156 59.7099L196.186 59.719C196.748 59.8906 200.233 60.9536 200.959 61.1474C200.029 62.045 198.497 62.4776 195.28 62.0322C195.309 62.1334 195.338 62.2927 195.373 62.4858C195.496 63.1605 195.694 64.2478 196.216 64.7087C196.127 64.7547 195.615 64.9389 194.211 64.8209C193.98 64.7896 193.701 64.723 193.384 64.6475C193.02 64.5607 192.605 64.4621 192.157 64.391C191.318 64.2581 190.16 64.1551 189.039 64.4839C189.039 64.4788 189.04 64.4731 189.04 64.467C189.064 63.9755 189.25 60.1529 192.05 58.4661C192.122 58.4227 192.192 58.3805 192.259 58.3394C193.611 57.5189 194.218 57.1506 198.888 56.8646Z"
                fill="#B394F2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M203.297 56.055C202.079 56.7115 200.213 56.8041 198.888 56.865C193.984 57.1654 193.561 57.5564 192.05 58.4665C189.215 60.1744 189.06 64.0721 189.039 64.4843C190.16 64.1555 191.318 64.2585 192.157 64.3914C192.996 64.5244 193.715 64.754 194.211 64.8213C195.615 64.9393 196.127 64.7551 196.216 64.7092C195.545 64.1163 195.409 62.4871 195.28 62.0326C198.497 62.478 200.029 62.0454 200.959 61.1478C200.218 60.9501 196.608 59.8484 196.155 59.7103C197.642 59.2962 201.094 58.4123 202.004 57.7445C202.622 57.2958 202.903 56.9946 203.297 56.055Z"
                fill="#B394F2"
            />
            <ellipse
                cx="135"
                cy="76.9961"
                rx="24"
                ry="23.9985"
                fill="#982EA9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M146.703 64.1689C144.894 66.5776 143.228 67.5972 140.218 68.217C129.598 70.4032 128.488 71.7292 126.19 73.7591C119.925 79.2913 122.852 88.7446 122.852 89.8294C124.319 88.0225 125.154 87.6687 127.3 87.1844C129.196 86.7563 131.686 87.21 132.846 87.1844C136.333 87.1061 139.344 85.6234 140.455 83.2813C139.345 83.2033 137.522 83.0469 137.127 82.1101C144.179 81.6417 146.319 76.9588 146.319 74.4611C144.892 75.0859 143.387 75.1634 142.3 75.0115C147.587 72.5101 147.734 69.0842 147.826 67.2802C147.905 65.7192 147.07 64.1689 146.703 64.1689Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M145.618 68.2864C143.792 69.6795 140.755 70.3164 138.597 70.7606C130.633 72.5273 130.04 73.2788 127.799 75.1641C123.593 78.7019 124.35 85.1352 124.423 85.8166C126.177 84.986 128.102 84.8542 129.513 84.8542C130.924 84.8542 132.162 85.044 132.994 85.0256C135.327 84.8542 136.118 84.4191 136.252 84.3207C134.998 83.5226 134.352 80.8859 134.022 80.1739C139.414 80.0685 141.814 78.961 143.106 77.2471C141.84 77.1153 135.634 76.2462 134.855 76.1373C137.186 75.0718 142.618 72.725 143.937 71.3935C144.833 70.497 145.216 69.9301 145.618 68.2864Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_878_6813">
                <rect width="270" height="110" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const MailBoxSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="270"
        height="110"
        viewBox="0 0 270 110"
    >
        <rect x="0" y="0" width="100%" height="100%" fill="#fff" />
        <g vectorEffect="non-scaling-stroke">
            <ellipse
                cx="0"
                cy="0"
                rx="38.5"
                ry="37.132"
                stroke="none"
                strokeWidth="1"
                strokeLinecap="butt"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#f5ebf7"
                fillRule="nonzero"
                opacity="1"
                transform="translate(136.463 51.273)"
            />
            <path
                d="M139 75.14h12v32a6 6 0 0 1-12 0v-32z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#3d5580"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M149.917 75.14H155v30.198c0 4.091-3.582 7.407-8 7.407 2.28-1.772 2.917-3.316 2.917-7.407V75.141z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#22385e"
                fillRule="nonzero"
                opacity="1"
            />
            <g transform="translate(144.502 56.026)">
                <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="49.503"
                    y1="24.531"
                    x2="49.503"
                    y2="59.521"
                >
                    <stop offset="0%" stopColor="#9da9bf" stopOpacity=".42" />
                    <stop offset="100%" stopColor="#8797b4" stopOpacity="1" />
                </linearGradient>
                <path
                    transform="translate(-49.502 -42.026)"
                    d="M56.061 24.53H29.828v34.99H69.177V37.21c0-7.002-5.676-12.68-12.679-12.68-.146 0-.292.003-.437.008v-.007z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="url(#a)"
                    fillRule="evenodd"
                    opacity="1"
                />
            </g>
            <path
                d="M104 71.321c0-.652.529-1.18 1.18-1.18H151v3.01a2.361 2.361 0 0 1-2.361 2.362h-42.278A2.361 2.361 0 0 1 104 73.152v-1.83z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#8898b5"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M112.778 51.123c0-6.954 5.638-12.592 12.592-12.592 6.955 0 12.593 5.638 12.593 12.592v18.113h-25.185V51.123z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#50668c"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M105.11 51.636l13.737 9.317 13.738-9.318v14.95a2.65 2.65 0 0 1-2.65 2.65H107.76a2.65 2.65 0 0 1-2.65-2.65v-14.95z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#c4cbd8"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M105.11 51.636l8.503 5.767c2.226 1.51 8.226 5.604 10.443 7.126l6.825 4.687c-.16.027-.37.019-.71.019h-22.418a2.644 2.644 0 0 1-2.643-2.65v-14.95z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#c4cbd8"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M118.847 51.428l13.366-.041c.262-.001.366.338.15.484l-13.512 9.103-13.499-9.087a.265.265 0 0 1 .148-.485l13.347.026z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#fff"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M133.212 50.568c0-4.332-1.627-8.614-5.64-10.715-.686-.36-2.6-1.122-5.165-.956 2.102-.496 3.609-.35 3.894-.332 6.515.426 11.662 5.637 11.662 12.003v18.668h-4.751V50.568z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#2a4473"
                fillRule="nonzero"
                opacity=".6"
            />
            <path
                d="M121.07 91.53l1.747-2.45 2.45 1.747-1.748 2.45-2.449-1.747z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#982ea9"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M101.017 35.593l3.65-1.664 1.663 3.65-3.65 1.664-1.663-3.65z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#e3c5e7"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M101.017 35.593l3.65-1.664 1.663 3.65-3.65 1.664-1.663-3.65z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#8155db"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M105.026 99.77l3.65-1.664 1.664 3.65-3.65 1.663-1.664-3.65zM146.14 31.026l1.621-3.113 3.113 1.62-1.62 3.113-3.113-1.62z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#d09fd8"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M95 88.077l.053-3.008 3.007.053-.052 3.008L95 88.077z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#8155db"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M134.021 22.866l1.087-2.56 2.56 1.087-1.087 2.56-2.56-1.087z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#ab54b9"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M146.933 31.655a2.515 2.515 0 0 1 2.515-2.514h.285V54.4h-2.8V31.655z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#2a4473"
                fillRule="nonzero"
                opacity="1"
            />
            <path
                d="M149.733 29.14h6.495A3.772 3.772 0 0 1 160 32.914v.876a3.772 3.772 0 0 1-3.772 3.772h-6.495v-8.42z"
                strokeLinecap="butt"
                stroke="none"
                strokeWidth="1"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#982ea9"
                fillRule="nonzero"
                opacity="1"
            />
            <ellipse
                cx="0"
                cy="0"
                rx="2.25"
                ry="2.255"
                stroke="none"
                strokeWidth="1"
                strokeLinecap="butt"
                strokeDashoffset="0"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                fill="#2a4473"
                fillRule="nonzero"
                opacity="1"
                transform="translate(148.25 54.819)"
            />
        </g>
        <g vectorEffect="non-scaling-stroke">
            <g transform="translate(223.999 96.997)" clipPath="url(#b)">
                <clipPath id="b">
                    <rect
                        transform="translate(-88.999 -48.997)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M6.002-2.8l-8.8-3.203L-6.002 2.8l8.801 3.203L6.002-2.8z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#982ea9"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g
                transform="matrix(-.9397 -.3421 -.342 .9397 146.502 11.003)"
                clipPath="url(#c)"
            >
                <clipPath id="c">
                    <rect
                        transform="matrix(-.9397 -.3421 -.342 .9397 -1.839 38.7)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <rect
                    x="-4.683"
                    y="-4.684"
                    rx="0"
                    ry="0"
                    width="9.365"
                    height="9.367"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#982ea9"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g transform="translate(180.144 91.137)" clipPath="url(#d)">
                <clipPath id="d">
                    <rect
                        transform="translate(-45.144 -43.137)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M1.282-5.142l-6.423 3.86 3.86 6.424 6.422-3.86-3.859-6.424z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#e3c5e7"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g transform="translate(43.118 89.867)" clipPath="url(#e)">
                <clipPath id="e">
                    <rect
                        transform="translate(91.882 -41.867)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M4.118-3.335l-7.452-.783-.784 7.453 7.452.783.784-7.453z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#b394f2"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g
                transform="matrix(-.9903 -.1392 -.1391 .9903 95.66 12.645)"
                clipPath="url(#f)"
            >
                <clipPath id="f">
                    <rect
                        transform="scale(-1 1) rotate(-8.001 233.074 -298.905)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <rect
                    x="-2.342"
                    y="-2.343"
                    rx="0"
                    ry="0"
                    width="4.685"
                    height="4.685"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#bd79c8"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g
                transform="matrix(-.5664 -.8242 -.8241 .5664 205.256 26.256)"
                clipPath="url(#g)"
            >
                <clipPath id="g">
                    <rect
                        transform="scale(-1 1) rotate(-55.499 55.794 55.907)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <rect
                    x="-2.342"
                    y="-2.343"
                    rx="0"
                    ry="0"
                    width="4.685"
                    height="4.685"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#bd79c8"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g
                transform="matrix(-.829 -.5593 -.5591 .8291 112.212 34.2)"
                clipPath="url(#h)"
            >
                <clipPath id="h">
                    <rect
                        transform="matrix(-.8291 -.5593 -.5591 .829 -26.613 -1.305)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <rect
                    x="-3.747"
                    y="-3.747"
                    rx="0"
                    ry="0"
                    width="7.493"
                    height="7.494"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#b394f2"
                    fillRule="nonzero"
                    opacity=".8"
                />
            </g>
            <g
                transform="matrix(-.9781 -.208 -.2079 .9782 171.611 30.06)"
                clipPath="url(#i)"
            >
                <clipPath id="i">
                    <rect
                        transform="matrix(-.9781 -.2079 -.2079 .9782 32.085 25.16)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <rect
                    x="-2.81"
                    y="-2.81"
                    rx="0"
                    ry="0"
                    width="5.62"
                    height="5.62"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#b394f2"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g
                transform="matrix(-.9781 -.208 -.2079 .9782 101.345 95.328)"
                clipPath="url(#j)"
            >
                <clipPath id="j">
                    <rect
                        transform="matrix(-.9781 -.2079 -.2079 .9782 -23.08 -53.292)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <rect
                    x="-2.81"
                    y="-2.81"
                    rx="0"
                    ry="0"
                    width="5.62"
                    height="5.62"
                    stroke="none"
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#982ea9"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g transform="translate(220.947 68.453)" clipPath="url(#k)">
                <clipPath id="k">
                    <rect
                        transform="translate(-85.948 -20.453)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M8.049 2.543C6.138-.329.243-5.044-8.048-.929"
                    strokeLinecap="round"
                    stroke="#bd79c8"
                    strokeWidth="2"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="none"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g transform="translate(71.05 79.976)" clipPath="url(#l)">
                <clipPath id="l">
                    <rect
                        transform="translate(63.95 -31.976)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M-7.55-3.684C-5.506.13.373 6.64 7.55 2.18"
                    strokeLinecap="round"
                    stroke="#982ea9"
                    strokeWidth="2"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="none"
                    fillRule="nonzero"
                    opacity="1"
                />
            </g>
            <g transform="translate(70.224 50.745)" clipPath="url(#m)">
                <clipPath id="m">
                    <rect
                        transform="translate(64.776 -2.745)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M-2.928-4.596c-1.622-.276-2.532-.79-3.545-2.045-.197.007-.614.852-.542 1.685v.015c.084.967.24 2.785 3.1 4.018a4.106 4.106 0 0 1-2.16-.22c.047 1.336 1.279 3.802 5.06 3.92-.194.51-1.166.627-1.758.69.638 1.231 2.276 1.968 4.143 1.945.192-.002.452-.032.75-.065.662-.075 1.51-.172 2.216-.038 1.157.219 1.61.393 2.429 1.332-.003-.082.022-.255.058-.5.218-1.483.82-5.594-2.145-8.034l-.165-.137C3.347-2.998 2.54-3.668-2.928-4.596zm.914 1.33c-1.163-.197-2.799-.482-3.802-1.193.246.872.461 1.168.958 1.63.64.605 2.99 1.567 4.413 2.15l.533.22-.027.004c-.515.09-3.704.65-4.365.743.723.892 2.027 1.44 4.913 1.396-.036.086-.079.224-.13.39-.182.582-.475 1.52-.985 1.87.074.05.505.268 1.756.316.207-.002.46-.031.749-.063.33-.037.707-.08 1.11-.093.754-.027 1.786.008 2.74.42l.001-.015c.032-.437.282-3.83-2.006-5.62l-.17-.135c-1.105-.87-1.6-1.261-5.688-2.02z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#bd79c8"
                    fillRule="evenodd"
                    opacity="1"
                />
            </g>
            <g transform="translate(70.253 50.778)" clipPath="url(#n)">
                <clipPath id="n">
                    <rect
                        transform="translate(64.747 -2.778)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M-5.845-4.491c1.003.711 2.64.995 3.802 1.193 4.293.796 4.624 1.187 5.858 2.154C6.131.67 5.847 4.126 5.82 4.49c-.953-.411-1.985-.446-2.74-.42-.755.026-1.414.151-1.859.157C-.03 4.179-.46 3.962-.535 3.91c.656-.45.952-1.873 1.115-2.26-2.886.045-4.19-.503-4.913-1.396C-3.66.161-.355-.419.059-.492c-1.267-.527-4.216-1.68-4.946-2.369-.497-.462-.712-.759-.958-1.63z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#bd79c8"
                    fillRule="evenodd"
                    opacity="1"
                />
            </g>
            <g transform="translate(196.74 53.215)" clipPath="url(#o)">
                <clipPath id="o">
                    <rect
                        transform="translate(-61.74 -5.215)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M3.851-4.71c1.85-.086 2.936-.535 4.24-1.797.217.034.568 1.035.373 1.956l-.003.016c-.225 1.068-.648 3.077-4.01 4.062a4.618 4.618 0 0 0 2.441.05C6.657 1.064 4.943 3.648.704 3.262c.147.595 1.217.86 1.87 1.01C1.691 5.56-.24 6.158-2.32 5.876c-.215-.03-.5-.098-.829-.176-.729-.175-1.664-.4-2.47-.347-1.323.086-1.852.218-2.895 1.154a4.57 4.57 0 0 0 .003-.566c-.04-1.686-.15-6.36 3.496-8.677l.203-.13c1.436-.921 2.43-1.558 8.663-1.845zM2.647-3.35c1.326-.062 3.192-.154 4.41-.81-.395.939-.676 1.24-1.293 1.689C4.965-1.885 2.21-1.133.541-.677c-.233.063-.444.12-.626.172l.03.009C.508-.325 3.992.738 4.718.932c-.93.898-2.46 1.33-5.679.885.03.101.058.26.093.453.123.675.322 1.762.843 2.223-.089.046-.6.23-2.004.113a9.247 9.247 0 0 1-.828-.174 15.957 15.957 0 0 0-1.227-.256c-.839-.133-1.996-.236-3.117.093v-.017c.024-.492.211-4.314 3.011-6.001l.21-.127c1.351-.82 1.958-1.189 6.627-1.475z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#b394f2"
                    fillRule="evenodd"
                    opacity="1"
                />
            </g>
            <g transform="translate(196.668 53.458)" clipPath="url(#p)">
                <clipPath id="p">
                    <rect
                        transform="translate(-61.668 -5.458)"
                        x="-135"
                        y="-55"
                        rx="0"
                        ry="0"
                        width="270"
                        height="110"
                    />
                </clipPath>
                <path
                    d="M7.129-4.403c-1.217.657-3.084.75-4.409.81-4.903.3-5.327.692-6.838 1.602-2.835 1.708-2.99 5.606-3.011 6.018 1.122-.33 2.279-.226 3.118-.093s1.558.362 2.055.43c1.404.118 1.915-.067 2.004-.112-.671-.593-.807-2.223-.936-2.677 3.218.445 4.749.013 5.679-.885C4.051.492.441-.61-.012-.747c1.487-.414 4.939-1.298 5.849-1.966.617-.449.898-.75 1.292-1.69z"
                    strokeLinecap="butt"
                    stroke="none"
                    strokeWidth="1"
                    strokeDashoffset="0"
                    strokeLinejoin="miter"
                    strokeMiterlimit="4"
                    fill="#b394f2"
                    fillRule="evenodd"
                    opacity="1"
                />
            </g>
        </g>
    </svg>
);

export const MailBoxMobileSVG = () => (
    <svg
        width="83"
        height="80"
        viewBox="0 0 83 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="43" cy="40" r="40" fill="white" />
        <mask
            id="mask0_small"
            maskUnits="userSpaceOnUse"
            x="3"
            y="0"
            width="80"
            height="80"
        >
            <circle cx="43" cy="40" r="40" fill="white" />
        </mask>
        <g mask="url(#mask0_small)">
            <path
                d="M37.7861 54.5648H49.3246V81.0734C49.3246 84.2596 46.7416 86.8426 43.5554 86.8426C40.3691 86.8426 37.7861 84.2596 37.7861 81.0734V54.5648Z"
                fill="#3D5580"
            />
            <path
                d="M45.415 54.5648H49.3247V80.4848C49.3247 83.9961 46.5696 86.8426 43.1709 86.8426C44.9242 85.3211 45.415 83.9961 45.415 80.4849V54.5648Z"
                fill="#22385E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.598 54.6154H31.0688V16.9231H58.3112V16.9308C58.4619 16.9257 58.6133 16.9231 58.7652 16.9231C66.0372 16.9231 71.9324 22.8182 71.9324 30.0903V54.6154H58.3112H45.598Z"
                fill="url(#paint0_linear_small)"
            />
            <path
                d="M8.55566 50.861C8.55566 50.3599 8.96185 49.9537 9.4629 49.9537H44.7095V52.7504C44.7095 53.7525 43.8971 54.5648 42.895 54.5648H10.3701C9.36803 54.5648 8.55566 53.7525 8.55566 52.7504V50.861Z"
                fill="#8898B5"
            />
            <path
                d="M18.5552 30C18.5552 22.7778 24.4099 16.9231 31.6321 16.9231C38.8543 16.9231 44.709 22.7778 44.709 30V50H18.5552V30Z"
                fill="#50668C"
            />
            <path
                d="M10.5928 31.0402L24.8586 41.0771L39.1245 31.0402V47.9627C39.1245 49.0872 38.2129 49.9988 37.0884 49.9988H12.6289C11.5044 49.9988 10.5928 49.0872 10.5928 47.9627L10.5928 31.0402Z"
                fill="#C4CBD8"
            />
            <path
                d="M10.5928 31.0402L20.8 38.2216C22.5069 39.4225 27.1999 42.7446 28.8998 43.9553C30.7463 45.2705 33.4364 47.1865 37.3557 49.978C37.1887 50.0079 36.9714 49.9988 36.6171 49.9988C36.2528 49.9979 35.5534 49.9988 35.1504 49.9988C34.2175 49.9988 18.3365 49.9988 12.6213 49.9988C11.4968 49.9988 10.5928 49.0872 10.5928 47.9627L10.5928 31.0402Z"
                fill="#E9ECF1"
            />
            <g filter="url(#filter0_d_small)">
                <path
                    d="M24.8579 30.817L38.9939 30.7713C39.1934 30.7707 39.2747 31.0276 39.1112 31.1418L24.8624 41.1001L10.6263 31.1591C10.4628 31.0449 10.5439 30.7881 10.7433 30.7885L24.8579 30.817Z"
                    fill="white"
                />
            </g>
            <path
                opacity="0.6"
                d="M39.7753 29.8896C39.7753 25.2231 38.0864 20.6107 33.9196 18.3478C33.2064 17.9605 31.2183 17.1391 28.5552 17.3171C30.7382 16.7829 32.3025 16.9398 32.5989 16.9599C39.3641 17.4191 44.709 23.0324 44.709 29.8896V50H39.7753V29.8896Z"
                fill="#2A4473"
            />
        </g>
        <path
            d="M51.1606 6.37545C51.1606 5.30805 52.0259 4.44275 53.0933 4.44275H54.1671V31.5006H51.1606V6.37545Z"
            fill="#2A4473"
        />
        <path
            d="M54.1665 4.44275H62.291C63.8921 4.44275 65.1901 5.7407 65.1901 7.3418V10.563C65.1901 12.1641 63.8921 13.462 62.291 13.462H54.1665V4.44275Z"
            fill="#982EA9"
        />
        <circle cx="52.5741" cy="31.9479" r="2.41588" fill="#2A4473" />
        <rect
            x="20.0356"
            y="59.4748"
            width="2.31192"
            height="2.31192"
            transform="rotate(-54.5 20.0356 59.4748)"
            fill="#982EA9"
        />
        <rect
            x="4.62354"
            y="16.4864"
            width="3.08256"
            height="3.08256"
            transform="rotate(-24.5 4.62354 16.4864)"
            fill="#E3C5E7"
        />
        <rect
            x="4.62354"
            y="16.4864"
            width="3.08256"
            height="3.08256"
            transform="rotate(-24.5 4.62354 16.4864)"
            fill="#8155DB"
        />
        <rect
            x="7.70508"
            y="65.8074"
            width="3.08256"
            height="3.08256"
            transform="rotate(-24.5 7.70508 65.8074)"
            fill="#D09FD8"
        />
        <rect
            x="39.3027"
            y="12.9765"
            width="2.69724"
            height="2.69724"
            transform="rotate(-62.5 39.3027 12.9765)"
            fill="#D09FD8"
        />
        <rect
            y="56.8216"
            width="2.31192"
            height="2.31192"
            transform="rotate(-89 0 56.8216)"
            fill="#8155DB"
        />
        <path
            d="M3.1007 39.1215C2.06594 38.2265 0.499426 35.7513 2.51142 33.011"
            stroke="#982EA9"
            strokeWidth="0.88875"
            strokeLinecap="round"
        />
        <path
            d="M18.7539 10.5835C19.9521 11.2438 21.999 13.3392 20.6007 16.4379"
            stroke="#BD79C8"
            strokeWidth="0.88875"
            strokeLinecap="round"
        />
        <rect
            x="29.9888"
            y="6.70563"
            width="2.13722"
            height="2.13722"
            transform="rotate(-67 29.9888 6.70563)"
            fill="#AB54B9"
        />
        <defs>
            <filter
                id="filter0_d_small"
                x="8.40609"
                y="29.7048"
                width="32.9256"
                height="14.5947"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.06649" />
                <feGaussianBlur stdDeviation="1.06649" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_small"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_small"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_small"
                x1="51.5006"
                y1="16.9231"
                x2="51.5006"
                y2="54.6154"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9DA9BF" stopOpacity="0.42" />
                <stop offset="1" stopColor="#8797B4" />
            </linearGradient>
        </defs>
    </svg>
);
